const strapiUrl = (resourceUrl: string) => `${process.env.GATSBY_STRAPI_URL}${resourceUrl}`
export default strapiUrl